import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="bg-white">
      <section className="bg-white">
        <div className="mx-3 md:mx-10 lg:mx-16 py-16 md:py-20">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-inter font-medium text-acBlack leading-[1.05]">
              Terms of Use
            </h1>

            <div className="mt-6 rounded-2xl bg-gray-50 border border-gray-100 px-6 md:px-8 py-5">
              <div className="text-sm md:text-base text-acGray font-inter">
                <span className="font-semibold text-acBlack">Effective Date:</span> 30th September 2025
              </div>
            </div>

            <div className="mt-10 space-y-10">
              <div className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                Welcome to valicourses.com (the “Website”), operated by Validate Systems (“we”, “our”, “us”). By accessing
                or using this Website, you agree to be bound by these Terms of Use. If you do not agree, please do not use
                the Website.
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">1. About Valicourses</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses is a curated course discovery platform. We list and recommend business and technology
                  courses that are created, hosted, and sold by independent third-party providers.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">We do not:</p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Host course content</li>
                  <li>Process payments</li>
                  <li>Provide learning services</li>
                  <li>Guarantee outcomes from any course</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Our role is limited to discovery and referral.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">2. Use of the Website</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  You may use this Website for lawful purposes only. You agree not to:
                </p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Use the Website in violation of any applicable laws or regulations</li>
                  <li>Attempt to disrupt or interfere with the Website’s functionality</li>
                  <li>Copy, scrape, or reproduce content without permission</li>
                  <li>Misrepresent your affiliation with Valicourses or Validate Systems</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  We reserve the right to restrict access to the Website if misuse is detected.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">
                  3. Third-Party Courses and Platforms
                </h2>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Courses listed on Valicourses link to external platforms, including but not limited to:
                </p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Selar</li>
                  <li>Lemon Squeezy</li>
                  <li>Gumroad</li>
                  <li>Udemy</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  When you click a course link, you leave our Website and interact directly with a third-party provider.
                  Any purchase, course access, refunds, or disputes are strictly between you and the third-party platform
                  or course creator.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">Valicourses is not responsible for:</p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Course quality or outcomes</li>
                  <li>Pricing or payment processing</li>
                  <li>Refunds or cancellations</li>
                  <li>Availability or delivery of course content</li>
                </ul>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">4. No Guarantees or Warranties</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  All information on Valicourses is provided for general informational purposes only.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">We do not guarantee that:</p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Any course will meet your expectations</li>
                  <li>Any specific result, income, or career outcome will be achieved</li>
                  <li>Course information is free from errors or omissions</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Course descriptions are provided by creators or third-party platforms and are displayed as received.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">5. Intellectual Property</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  All Website content, including text, layout, branding, and design elements, is the property of Validate
                  Systems unless otherwise stated.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  You may not reproduce, distribute, or modify Website content without prior written permission.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Course content remains the intellectual property of the respective creators and hosting platforms.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">6. Limitation of Liability</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  To the maximum extent permitted by law, Validate Systems and Valicourses shall not be liable for any
                  direct, indirect, incidental, or consequential damages arising from:
                </p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Use or inability to use the Website</li>
                  <li>Reliance on course listings or descriptions</li>
                  <li>Transactions conducted on third-party platforms</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Your use of the Website is at your own discretion and risk.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">7. External Links</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  The Website may contain links to external websites for convenience. We do not endorse, control, or assume
                  responsibility for the content, policies, or practices of any third-party websites.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Accessing external links is done at your own risk.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">8. Termination</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  We reserve the right to suspend or terminate access to the Website at any time, without notice, if these
                  Terms of Use are violated.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">9. Governing Law</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  These Terms of Use are governed by and construed in accordance with the laws of the Federal Republic of
                  Nigeria, without regard to conflict of law principles.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">10. Changes to These Terms</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  We may update these Terms of Use from time to time. Any changes will be posted on this page with an
                  updated effective date. Continued use of the Website after changes constitutes acceptance of the revised
                  Terms.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">11. Contact Information</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  If you have questions about these Terms of Use, please contact us:
                </p>

                <div className="rounded-2xl bg-white border border-gray-100 px-6 md:px-8 py-6">
                  <div className="text-sm md:text-base text-acBlack font-inter font-semibold">Validate Systems</div>
                  <div className="mt-2 text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                    36, Ilupeju Street, Camp FUNAAB
                    <br />
                    Ogun State, Nigeria
                  </div>
                  <div className="mt-4 text-sm md:text-base text-gray-700 font-inter">
                    <span className="font-semibold text-acBlack">Email:</span> privacy@valicourses.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUse;
